import React from "react";
import { Loader2, FileText } from "lucide-react";

export default function LoadingScreen({ message = "Caricamento...", darkMode = false }) {
  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center transition-colors ${
        darkMode ? "bg-neutral-950" : "bg-neutral-50"
      }`}
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className={`p-4 rounded-2xl ${
            darkMode ? "bg-forfy-900/30" : "bg-forfy-50"
          }`}
        >
          <FileText
            className={`w-8 h-8 ${
              darkMode ? "text-forfy-300" : "text-forfy-600"
            }`}
          />
        </div>
        <Loader2
          className={`w-6 h-6 animate-spin ${
            darkMode ? "text-forfy-300" : "text-forfy-600"
          }`}
        />
        <p
          className={`text-sm ${
            darkMode ? "text-neutral-500" : "text-neutral-600"
          }`}
        >
          {message}
        </p>
      </div>
    </div>
  );
}

// Componente skeleton per card KPI
export function KpiSkeleton({ darkMode = false }) {
  return (
    <div
      className={`rounded-2xl p-4 animate-pulse ${
        darkMode ? "bg-neutral-900" : "bg-white"
      }`}
    >
      <div
        className={`h-4 w-20 rounded mb-3 ${
          darkMode ? "bg-neutral-800" : "bg-neutral-200"
        }`}
      />
      <div
        className={`h-8 w-28 rounded ${
          darkMode ? "bg-neutral-800" : "bg-neutral-200"
        }`}
      />
    </div>
  );
}

// Componente skeleton per tabella
export function TableSkeleton({ rows = 5, darkMode = false }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className={`h-12 rounded-lg animate-pulse ${
            darkMode ? "bg-neutral-900" : "bg-neutral-100"
          }`}
        />
      ))}
    </div>
  );
}
